import { AuthenticationOptions, IAuthTokenResponseDTO } from '@core/models/auth';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveAuthReturnTo } from '@utils/authReturnTo';
import axios from 'axios';

function useRefreshToken() {
  const tokens = JSON.parse(localStorage.getItem('tokens') ?? 'null');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['refresh-token'],
    mutationFn: async () => {
      try {
        const response = await axios.post<IAuthTokenResponseDTO>(
          `${import.meta.env.VITE_APP_BFF_ANALYTICS}/auth/token`,
          {
            grantType: 'refresh_token',
            refreshToken: tokens?.refresh_token,
            clientId: AuthenticationOptions.clientId,
          }
        );

        const refreshedTokens = response.data;

        localStorage.setItem('tokens', JSON.stringify(refreshedTokens));

        await queryClient.refetchQueries({ queryKey: ['imagery-base-user'] });
      } catch (error) {
        console.error('Refresh Token Error:', error);
        localStorage.removeItem('tokens');

        // Still on the requested page here; the redirect below discards the URL.
        saveAuthReturnTo(`${globalThis.location.pathname}${globalThis.location.search}`);

        globalThis.location.href = `${
          import.meta.env.VITE_APP_CROPWISE_AUTH
        }/oauth/authorize?response_type=code&client_id=${
          import.meta.env.VITE_APP_CLIENT_ID
        }&redirect_uri=${globalThis.location.origin}/${import.meta.env.VITE_APP_REDIRECT_URI}`;
      }
    },
  });
}

export { useRefreshToken };
